import React from 'react';
import { 
    Dumbbell, 
    Brain, 
    Apple, 
    Calendar, 
    Clock,
    Box
} from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { useTranslations } from '@/lib/translations';

export const FeaturesSection = () => {
    const t = useTranslations();
    
    const features = [
        {
            icon: Brain,
            title: t.aiPoweredCoaching,
            description: t.aiPoweredCoachingDesc
        },
        {
            icon: Dumbbell,
            title: t.exerciseLibrary,
            description: t.exerciseLibraryDesc
        },
        {
            icon: Apple,
            title: t.nutritionGuidance,
            description: t.nutritionGuidanceDesc
        },
        {
            icon: Calendar,
            title: t.workoutPlanning,
            description: t.workoutPlanningDesc
        },
        {
            icon: Clock,
            title: t.availability,
            description: t.availabilityDesc
        },
        {
            icon: Box,
            title: t.digitalTwins,
            description: t.digitalTwinsDesc
        },
    ];

    return (
        <section id="features" className="relative py-16 overflow-hidden">
            {/* Background */}
            <div className="absolute inset-0 bg-card" />
            <div className="absolute inset-0 noise-bg" />
            
            <div className="container mx-auto px-4 relative z-10">
                {/* Section Header */}
                <div className="text-center mb-10">
                    <p className="text-primary font-semibold tracking-widest uppercase text-sm mb-2">
                        {t.features}
                    </p>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-wider mb-3 text-foreground">
                        {t.featuresTitle}
                    </h2>
                    <p className="text-foreground/80 text-base max-w-xl mx-auto">
                        {t.featuresSubtitle}
                    </p>
                </div>

                {/* Features Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {features.map((feature, index) => (
                        <Card 
                            key={feature.title}
                            className="group bg-secondary/30 border-border/50 hover:border-primary/30 transition-all duration-300 hover:shadow-gold"
                            style={{ animationDelay: `${index * 0.1}s` }}
                        >
                            <CardContent className="p-5">
                                <div className="w-11 h-11 rounded-lg gradient-gold flex items-center justify-center mb-3 group-hover:shadow-gold transition-shadow duration-300">
                                    <feature.icon className="w-5 h-5 text-primary-foreground" />
                                </div>
                                <h3 className="font-semibold text-base text-foreground mb-1.5">
                                    {feature.title}
                                </h3>
                                <p className="text-foreground/80 text-sm leading-relaxed">
                                    {feature.description}
                                </p>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;
